// A stable per-tab identifier, generated once when the module loads. It is used to
//   (a) open the board events SSE stream (?clientId=), and
//   (b) tag every change this tab broadcasts,
// so the tab's own changes — already applied locally (optimistic + in-process signal) — are
// not echoed back to it over the wire (the hybrid live-sync model). Per-tab, not per-user:
// two tabs of the same user should still sync to each other.
function generateClientId(): string {
  const cryptoObj: Crypto | undefined = typeof crypto !== "undefined" ? crypto : undefined;
  if (cryptoObj && typeof cryptoObj.randomUUID === "function") {
    return cryptoObj.randomUUID();
  }
  return `board-${Date.now().toString(36)}-${Math.random().toString(36).slice(2, 10)}`;
}

export const BOARD_CLIENT_ID: string = generateClientId();
